module.exports = __webpack_public_path__ + "img/p1-m@2x.8652f885.jpg";